import { NSARouterMakerResult } from "namirasoft-account-react";
import { CurrencyInputRow, CurrencyRow } from "namirasoft-erp";
import { NSBox, NSBoxBoolean, NSBoxInteger, NSBoxString, NSBoxTextArea, NSColumn } from "namirasoft-site-react";
import { Component, createRef } from "react";
import { ErpEntities } from "../ErpEntities";
import { ErpLayout } from '../ErpLayout';
import { ErpRouterProps } from "../ErpRouterProps";
import { ErpScopeMode } from "../ErpScope";

interface Props extends NSARouterMakerResult, ErpRouterProps { isEdit: boolean; }

export default class CurrencyEditPage extends Component<Props>
{
    Name = createRef<NSBoxString>();
    FractionName = createRef<NSBoxString>();
    FractionValue = createRef<NSBoxInteger>();
    Symbol = createRef<NSBoxString>();
    Description = createRef<NSBoxTextArea>();
    Enabled = createRef<NSBoxBoolean>();

    override render()
    {
        return (
            <ErpLayout<CurrencyRow, CurrencyInputRow>
                {...this.props}
                mode={ErpScopeMode.None}
                pages={{
                    entity: ErpEntities.currency(this.props),
                    edit: {
                        ...this.props,
                        ui: {
                            tab_page_edit: {
                                editor: {
                                    getInputRow: (): CurrencyInputRow => ({
                                        name: this.Name.current?.getValue() ?? "",
                                        fraction_name: this.FractionName.current?.getValue() ?? "",
                                        fraction_value: this.FractionValue.current?.getValue() ?? 0,
                                        symbol: this.Symbol.current?.getValue() ?? "",
                                        description: this.Description.current?.getValue() ?? null,
                                        enabled: this.Enabled.current?.getValueBool() ?? true,
                                        currency_category: [],
                                        currency_tag: [],
                                        currency_field: [],
                                    }),
                                    setRow: (row: CurrencyRow) =>
                                    {
                                        this.Name.current?.setValue(row.name);
                                        this.FractionName.current?.setValue(row.fraction_name);
                                        this.FractionValue.current?.setValue(row.fraction_value);
                                        this.Symbol.current?.setValue(row.symbol);
                                        this.Description.current?.setValue(row.description);
                                        this.Enabled.current?.setValueBool(row.enabled);
                                    }
                                }
                            }
                        }
                    }
                }}
            >
                <NSColumn>
                    <NSBoxString ref={this.Name} required title="Name" info={{ link: "https://namirasoft.com/erp/console-guide/currency/#field-name" }} style={{ width: NSBox.width.double }} />
                    <NSBoxString ref={this.FractionName} required={false} title="Fraction Name" info={{ link: "https://namirasoft.com/erp/console-guide/currency/#field-fraction-name" }} style={{ width: NSBox.width.double }} />
                    <NSBoxInteger ref={this.FractionValue} required={false} title="Fraction Value" info={{ link: "https://namirasoft.com/erp/console-guide/currency/#field-fraction-value" }} style={{ width: NSBox.width.double }} />
                    <NSBoxString ref={this.Symbol} required title="Symbol" info={{ link: "https://namirasoft.com/erp/console-guide/currency/#field-symbol" }} style={{ width: NSBox.width.double }} />
                    <NSBoxTextArea ref={this.Description} required={false} title="Description" info={{ link: "https://namirasoft.com/erp/console-guide/currency/#field-description" }} style={{ width: NSBox.width.double }} />
                    <NSBoxBoolean ref={this.Enabled} required checked={true} title="Enabled" info={{ link: "https://namirasoft.com/erp/console-guide/currency/#field-enabled" }} style={{ width: NSBox.width.double }} />
                </NSColumn>
            </ErpLayout>
        );
    }
}